import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './UsageCard.Styles';

function UsageCard({
  title,
  date,
  subtitle,
  renderHeaderRightSection,
  containerStyle,
  children,
  renderFooter,
  ...props
}) {
  const theme = useTheme();

  return (
    <View style={[styles.containerStyle(theme), containerStyle]}>
      <View style={styles.rowContainerStyle}>
        <VFText i18nKey={title} type="primary" style={styles.titleStyle} />
        {_isFunction(renderHeaderRightSection) ? renderHeaderRightSection() : null}
      </View>
      <View style={styles.rowContainerStyle}>
        <VFText i18nKey={date} type="primary" style={styles.dateTextStyle} />
        {subtitle ? (
          <VFText i18nKey={subtitle} type="primary" style={styles.subtitleTextStyle} />
        ) : null}
      </View>

      <View style={styles.separator(theme)} />
      {children}
      {_isFunction(renderFooter) ? renderFooter() : null}
    </View>
  );
}

UsageCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  renderHeaderRightSection: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  children: PropTypes.node,
  renderFooter: PropTypes.func,
};

export default UsageCard;
